<div fxLayout="column" class="height-100">
  <h1 mat-dialog-title fxLayout fxLayoutAlign="space-between center" class="no-margin">
    <div id="id_gen_coup_header" mat-typography>
      {{ 'LABEL_GENERATE_COUPON' | translate }}
    </div>
  
    <div>
      <button id="id_close_btn" mat-icon-button [matTooltip]="'LABEL_CLOSE' | translate" (click)='dialogRef.close()'>
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  </h1>

  <ng-container *ngIf="data?.campaign_distribution_data">
    <div fxLayout="column">
      <div id="id_campaign_details_lbl">
        {{ 'LABEL_CAMPAIGN' | translate }}: {{ data?.campaign_distribution_data.campaign_code }} - {{ data?.campaign_distribution_data.campaign_description }}
      </div>
  
      <div id="id_dist_details_lbl">
        {{ 'LABEL_DISTRIBUTION' | translate }}: {{ data?.campaign_distribution_data.distribution_code }} - {{ data?.campaign_distribution_data.distribution_description }}
      </div>
    </div>
  </ng-container>
  
  <div mat-dialog-content class="min-height-140 padding-5">
    <esc-step-four 
      [pre_generated_max_qty]="pre_generated_max_qty"
      [on_demand_max_qty]="on_demand_max_qty"
      (getCouponQty)="getCouponQty($event)"
      >
    </esc-step-four>
  </div>
  
  <div mat-dialog-actions *ngIf="!media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
    <button id="id_gen_btn" type="button" color="primary" mat-button (click)="generateCoupon()" [disabled]="!couponDetails">
      {{ 'LABEL_GENERATE' | translate }}
    </button>
    <button type="button" mat-button (click)="dialogRef.close()">
      {{ 'LABEL_CANCEL' | translate }}
    </button>
  </div>
  
  <!-- buttons for mobile view -->
  <div mat-dialog-actions *ngIf="media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
    <button id="id_cancel_btn" type="button" color="primary" mat-icon-button (click)="generateCoupon()" [disabled]="!couponDetails">
      <mat-icon svgIcon="check"></mat-icon>
    </button>
  
    <button type="button" mat-icon-button (click)="dialogRef.close()">
      <mat-icon svgIcon="cancel"></mat-icon>
    </button>
  </div>
</div>